import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Collapse from 'bootstrap/js/dist/collapse';
import { useLanguage } from '../../i18n/LanguageContext';

export default function Navbar() {
  const { languages, selectedLanguage, setSelectedLanguage, t } = useLanguage();
  const collapseRef = useRef(null);
  const bsCollapse = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const collapseElement = collapseRef.current;
    if (!collapseElement) return undefined;

    bsCollapse.current = new Collapse(collapseElement, { toggle: false });

    const handleShown = () => setIsOpen(true);
    const handleHidden = () => setIsOpen(false);

    collapseElement.addEventListener('shown.bs.collapse', handleShown);
    collapseElement.addEventListener('hidden.bs.collapse', handleHidden);

    return () => {
      collapseElement.removeEventListener('shown.bs.collapse', handleShown);
      collapseElement.removeEventListener('hidden.bs.collapse', handleHidden);
      bsCollapse.current?.dispose();
    };
  }, []);

  const toggleMenu = () => {
    bsCollapse.current?.toggle();
  };

  const closeMenu = () => {
    bsCollapse.current?.hide();
  };

  const sections = [
    { id: 'about', label: t('nav.about') },
    { id: 'experience', label: t('nav.experience') },
    { id: 'projects', label: t('nav.projects') },
    { id: 'contact', label: t('nav.contact') },
  ];

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
        <div className="container">
          <NavLink className="navbar-brand" to="/" onClick={closeMenu}>
            Zeeshan Ahmed
          </NavLink>

          <button
            className="navbar-toggler"
            type="button"
            aria-label={t('nav.toggle')}
            onClick={toggleMenu}
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div
            className="collapse navbar-collapse nav-collapse"
            ref={collapseRef}
          >
            <ul className="navbar-nav ms-auto">
              {sections.map(section => (
                <li key={section.id} className="nav-item">
                  <NavLink
                    to={`/${section.id}`}
                    className={({ isActive }) =>
                      `nav-link${isActive ? ' active' : ''}`
                    }
                    onClick={closeMenu}
                  >
                    {section.label}
                  </NavLink>
                </li>
              ))}
            </ul>

            <div className="language-switcher ms-lg-3 mt-3 mt-lg-0">
              <label className="visually-hidden" htmlFor="language-select">
                {t('language.label')}
              </label>
              <select
                id="language-select"
                className="form-select form-select-sm language-select"
                value={selectedLanguage}
                onChange={event => {
                  setSelectedLanguage(event.target.value);
                  closeMenu();
                }}
                aria-label={t('language.label')}
              >
                {languages.map(language => (
                  <option key={language.code} value={language.code}>
                    {language.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </nav>

      {isOpen && <div className="navbar-backdrop" onClick={closeMenu} />}
    </>
  );
}
